import React, { Component } from "react";
import { connect } from "react-redux";

import {
  changeLayout,
  changeTopbarTheme,
  changeLayoutTheme,
  toggleRightSidebar,
  changeLayoutWidth,
} from "../../store/actions";

// Other Layout related Component
import Navbar from "./Navbar";
import Header from "./Header";
import Footer from "./Footer";
import Rightbar from "../CommonForBoth/Rightbar";
import withRouter from "../Common/withRouter";
import BottomNavigationAdmin from "./MobileNavigation";

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMenuOpened: false
    };
    this.toggleRightSidebar = this.toggleRightSidebar.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.setMenuOpen = this.setMenuOpen.bind(this);
  }

  /**
  * Open/close right sidebar
  */
  toggleRightSidebar() {
    this.props.toggleRightSidebar();
  }

  /**
  * Toggle menu open/close
  */
  toggleMenu() {
    this.setState({ isMenuOpened: !this.state.isMenuOpened });
  }

  /**
  * Directly set menu open state
  */
  setMenuOpen(state) {
    this.setState({ isMenuOpened: state });
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      if (this.props.isPreloader) {
        document.getElementById("preloader").style.display = "block";
        document.getElementById("status").style.display = "block";

        setTimeout(() => {
          document.getElementById("preloader").style.display = "none";
          document.getElementById("status").style.display = "none";
        }, 2500);
      } else {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }

      // Ensure attributes are updated on layout change
      document.body.setAttribute("data-layout", "horizontal");
      document.body.setAttribute("data-topbar", "light");
    }
  }


  componentDidMount() {
    // Scroll to top
    window.scrollTo(0, 0);

    // Update document title
    const title = this.props.router.location.pathname;
    let currentPage = title.charAt(1).toUpperCase() + title.slice(2).replaceAll("-", " ");
    document.title = `${currentPage} | Brandstrek`;

    // Set layout to horizontal and topbar to light
    this.props.changeLayout("horizontal");
    this.props.changeTopbarTheme("light");
    this.props.changeLayoutTheme(this.props.theme);
    this.props.changeLayoutWidth(this.props.layoutWidth);

    // Always set `data-layout="horizontal"` & `data-topbar="light"`
    document.body.setAttribute("data-layout", "horizontal");
    document.body.setAttribute("data-topbar", "light");

    if (this.props.showRightSidebar) {
      this.toggleRightSidebar();
    }
  }

  /**
   * Opens the menu - mobile
   */
  openMenu = e => {
    this.toggleMenu();
  };

  render() {
    return (
      <React.Fragment>
        <div id="preloader">
          <div id="status">
            <div className="spinner">
              <i className="ri-loader-line spin-icon"></i>
            </div>
          </div>
        </div>

        <div id="layout-wrapper">
          <Header 
            theme={this.props.topbarTheme}
            isMenuOpened={this.state.isMenuOpened}
            toggleRightSidebar={this.toggleRightSidebar}
            openLeftMenuCallBack={this.openMenu}
          />
          <Navbar 
            menuOpen={this.state.isMenuOpened} 
            toggleMenu={this.toggleMenu}
            setMenuOpen={this.setMenuOpen}
          />
          <div className="main-content">
            {this.props.children}
            <Footer />
            <BottomNavigationAdmin/>
          </div>
        </div>
        <Rightbar />
      </React.Fragment>
    );
  }
}

const mapStatetoProps = state => {
  return {
    ...state.Layout
  };
};

export default connect(mapStatetoProps, {
  changeTopbarTheme, changeLayoutTheme, toggleRightSidebar, changeLayout, changeLayoutWidth
})(withRouter(Layout));